// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RSZD4b","desktop":"oEl2gz","mobile":"_18yZV1","withActions":"fPwZVv","content":"e4p+A4","actions":"cfGJ-s"};